/**
 * LUEYA — bundle-search-redirect.js
 * Detects bundle-related search queries ("bundle", "bundle 4 pieces", "4 pieces",
 * "bijoux bundle", accent/case-insensitive) and sends the shopper straight to
 * /pages/bundle-4-pieces instead of the classic search results page. Any other
 * query is untouched.
 *
 * Two layers, both required because this storefront has two separate search
 * entry points (the header's predictive search modal, and the /search page's
 * own input — see sections/predictive-search.liquid and blocks/_search-input.liquid):
 *
 *  1. Landing on the search results page itself with a matching `q` — redirected
 *     immediately. Covers direct URL entry/bookmarks, and the predictive search
 *     component's own "Enter with no suggestion highlighted" fallback (which sets
 *     location.href without calling preventDefault, so the browser's native form
 *     submission can still fire right after — this is the safety net if that race
 *     is ever lost).
 *  2. Submitting any on-site search form with a matching value — intercepted
 *     before the request ever reaches /search, via a capture-phase listener on
 *     `document` (runs before any listener on the form/input themselves).
 *
 * The technical "Bundle 4 Bijoux" product (handle bundle-4-bijoux) is also
 * rejected directly in sections/search-results.liquid and
 * sections/predictive-search.liquid, so it never appears in results regardless
 * of the query — this redirect is about intent-matching, not the sole guard
 * against that product surfacing.
 */
(function () {
  var BUNDLE_PAGE_URL = '/pages/bundle-4-pieces';

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  // "[47] pieces" : 4 = offre actuelle ; 7 = ancienne offre (avant le 2026-09-26),
  // gardée pour les clientes venues d'anciennes pubs.
  var BUNDLE_QUERY_PATTERNS = [/\bbundle\b/, /\b[47]\s*pieces\b/];

  function isBundleQuery(raw) {
    var normalized = normalize(raw);
    if (!normalized) return false;
    return BUNDLE_QUERY_PATTERNS.some(function (pattern) {
      return pattern.test(normalized);
    });
  }

  function getSearchPath() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.search_url) || '/search';
  }

  // Layer 1 — already on the search results page with a matching query.
  (function redirectIfAlreadyOnSearchPage() {
    if (window.location.pathname !== getSearchPath()) return;
    var params = new URLSearchParams(window.location.search);
    if (isBundleQuery(params.get('q'))) {
      window.location.replace(BUNDLE_PAGE_URL);
    }
  })();

  // Layer 2 — intercept the search form submission before it reaches /search.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('role') !== 'search') return;

      var input = form.querySelector('input[name="q"]');
      if (!input || !isBundleQuery(input.value)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = BUNDLE_PAGE_URL;
    },
    true
  );
})();
